import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { WalletIcon } from '@systemeio/ui/icons';
type PricePlanBaseProps = {
  additionalChild?: ReactNode;
};
const PricePlanBase: FC<PropsWithChildren<PricePlanBaseProps>> = t0 => {
  const $ = _c(14);
  const {
    children,
    additionalChild
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <WalletIcon className="fill-text-primary h-6 w-6 scale-75" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("dashboard.funnel.configuration.offer.price_plans_description");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.funnel.configuration.offer.price_plans");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3"><div className="text-text-primary flex flex-row items-center gap-1 text-sm font-normal lg:text-[15px]">{t1}<Hint label={t2}>{t3}</Hint></div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== additionalChild || $[9] !== t4) {
    t5 = <div className="flex flex-col justify-between gap-3 lg:flex-row lg:items-center lg:gap-0">{t4}{additionalChild}</div>;
    $[8] = additionalChild;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== t5) {
    t6 = <div className="flex flex-col gap-3 lg:gap-2">{t5}{children}</div>;
    $[11] = children;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default PricePlanBase;